export default "__VITE_ASSET__tMTfgZcGGlZOUyYIXeBUUQ__ 480w, __VITE_ASSET__ofY5jC19FGqQloXnUK9kgQ__ 745w";